module.exports = __webpack_public_path__ + "static/logo-94422437c25494b2b46b6fd736575394.png";